<template>
    <div class="select-coach-dialog">
        <el-dialog :title="$t('Sell.change_coach')" :visible.sync="visible" left>
            <el-table
                ref="table"
                highlight-current-row
                @current-change="handleCurrentChange"
                :data="staffs"
                border
                style="width: 100%">
                <el-table-column
                    prop="nickname"
                    :label="$t('Common.coach')">
                </el-table-column>
            </el-table>
            <div class="text-center mt-10">
                <el-button type="primary" @click="submit">
                    {{ $t('Sell.Dialog.modify_btn') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog } from 'element-ui';
import filterRole from '@/mixins/filterRole.js';

export default {
    props: ['activeName'],
    mixins: [filterRole],
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            contracts: null,
            staffs: [],
            selectItem: null,
        };
    },
    watch: {},
    methods: {
        open(data) {
            this.contracts = data;
            this.fetchStaff();
        },
        async fetchStaff() {
            const ids = [7,8];
            this.staffs = await this.filterRole(null, ids, null);
            this.visible = true;
        },
        handleCurrentChange(row) {
            this.selectItem = row;
        },
        submit() {
            if (!this.selectItem) return $ele.$message(this.$t('Choose.coach_one'));
            let form = {
                coachId: this.selectItem.id,
                contractNums: [],
            };
            form.contractNums = this.contracts.map(el => el.contractNum);
            API.post('contract/coach/coach', form).then(() => {
                $ele.$message.success(this.$t('Message.coach_success'));
                this.visible = false;
                this.$emit('fetchData');
            });
        },
    },
};

</script>
<style lang="scss">
.select-coach-dialog {
    .el-dialog {
        width: 55%;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 780px;
        overflow-y: auto;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .el-dialog__body {
        max-height: 720px;
        overflow-y: auto;
    }
    .has-gutter {
        th {
            background-color: #fafafa !important;
        }
    }
}
</style>
